import { types, prefix } from '../actions/dataSettingsDialog';
import optionsBase, { initialState as baseInitialState } from './optionsBase';

export const baseReducer = optionsBase(prefix);

export const initialState = {
  ...baseInitialState,
  dialogOpened: false,
};

export default (state = initialState, action) => {
  const interState = baseReducer(state, action);

  const { type } = action;

  switch (type) {
    case types.OPEN_DATA_SETTINGS_DIALOG:
      return {
        ...interState,
        dialogOpened: true,
      };

    case types.APPLY_DATA_SETTINGS_DIALOG:
    case types.CANCEL_DATA_SETTINGS_DIALOG:
      return {
        ...interState,
        dialogOpened: false,
      };

    default:
      return interState;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/dataSettingsDialog.js